import { authwsEnvironment } from '../authws-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { AuthHeaders } from '../../../models/auth-headers';
import { ssoUserSchema } from '../schemas/sso-user.schema';
import { fromFetch } from 'rxjs/fetch';

/**
 * Find a user by their email or username
 * @param email user's email address or username
 * @param alias account alias (only needed if searching for non-email users)
 * @returns User details
 */
export function getUsers(this: unknown, email: string, alias?: string) {
  const params = new URLSearchParams([['email', email]]);
  if (typeof alias !== 'undefined') {
    params.append('alias', alias);
  }
  return fromFetch(
    new Request(
      `${authwsEnvironment.resolve(this).usersUrl}?${params.toString()}`,
      {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
      }
    )
  ).pipe(selectData(ssoUserSchema.optional()));
}
